export default "__VITE_ASSET__CX3WIjWM__"